import {Content} from "#/src/pages/(legal)/polityka-prywatnosci/Content";

export {Page}

function Page() {
  return <div className={"h-100"}><Content/></div>
}
